import { render } from "./Investor.vue?vue&type=template&id=7d2a990c&scoped=true"
import script from "./Investor.vue?vue&type=script&lang=js"
export * from "./Investor.vue?vue&type=script&lang=js"

import "./Investor.vue?vue&type=style&index=0&id=7d2a990c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d2a990c"]])

export default __exports__